export const GET_HACKATHON_MATCHES_REQUEST = 'HackathonPage/GET_HACKATHON_MATCHES_REQUEST';
export const GET_HACKATHON_MATCHES_SUCCESS = 'HackathonPage/GET_HACKATHON_MATCHES_SUCCESS';
export const GET_HACKATHON_MATCHES_FAILURE = 'HackathonPage/GET_HACKATHON_MATCHES_FAILURE ';
